import { FormEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FaLock } from 'react-icons/fa'
import { Link } from 'react-router-dom';
import { LoginData } from '../../types';
import { login } from '../../utils/data';
import toast from 'react-hot-toast';
import { MdEmail } from 'react-icons/md';
const LoginForm = () => {
    const { t } = useTranslation();
    const [loginData, setLoginData] = useState<LoginData>({ email: '', password: '' });
    const handleLogin = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        try {
            await login(loginData);
        } catch (error) {
            toast.error('Failed to login. Please check your username and password.');
        }
    };
    return (
        <div className=' max-container padding-container rounded-md  relative z-30 bg-white xs:w-4/5 md:w-2/5 flex flex-col justify-center py-10 px-8'>
            <p className='text-[24px] text-black'>{t("hello-again")}</p>
            <p className='text-[28px] font-bold text-black'>{t("welcome-back")}</p>
            <form onSubmit={handleLogin}>
                <div className=" flex mt-8  mb-3 items-center border-[1px] rounded-md border-[#DDD] gap-1 p-3 text-[#a9a9a9]">
                    <MdEmail />
                    <input
                        type="text"
                        name="email"
                        placeholder={t("email")}
                        value={loginData.email}
                        onChange={(e) => setLoginData({ ...loginData, email: e.target.value })}
                        required
                        className='text-black w-full focus:outline-none bg-inherit'
                    />

                </div>
                <div className=" flex mb-3 items-center border-[1px] rounded-md border-[#DDD] gap-1 p-3 text-[#a9a9a9]">
                    <FaLock />
                    <input
                        type="password"
                        name="password"
                        placeholder={t("password")}
                        value={loginData.password}
                        onChange={(e) => setLoginData({ ...loginData, password: e.target.value })}
                        required
                        className='text-black w-full focus:outline-none bg-inherit'
                    />
                </div>
                <input type="submit"
                    value={t("login")}
                    className=" w-full cursor-pointer  mb-3 flex-center bg-primary border-[1px] rounded-md border-none gap-1 py-3 text-white"
                />
                <Link to="/forget-passward" className=" block  p-3 text-[#a9a9a9]">{t("forgot-password")}</Link>
                <Link to="/signUp" className="mb-3 p-3 text-primary">{t("don't-have-account")}</Link>
            </form>
        </div>
    )
}

export default LoginForm
